import type { Configuration, PopupRequest } from '@azure/msal-browser'

// Environment configuration - validate at startup
const CLIENT_ID = import.meta.env.VITE_AZURE_AD_CLIENT_ID || ''
const TENANT_ID = import.meta.env.VITE_AZURE_AD_TENANT_ID || ''
const REDIRECT_URI = import.meta.env.VITE_AZURE_AD_REDIRECT_URI || window.location.origin

// Log auth config for debugging (only in dev)
if (import.meta.env.DEV) {
  console.log('Auth Config:', {
    clientId: CLIENT_ID ? `${CLIENT_ID.substring(0, 8)}...` : 'MISSING',
    tenantId: TENANT_ID ? `${TENANT_ID.substring(0, 8)}...` : 'MISSING',
    redirectUri: REDIRECT_URI,
  })
}

// Warn if config is missing
if (!CLIENT_ID) {
  console.error('VITE_AZURE_AD_CLIENT_ID is not configured!')
}
if (!TENANT_ID) {
  console.error('VITE_AZURE_AD_TENANT_ID is not configured!')
}

// Get auth config - creates fresh config each time
export const getAuthConfig = (): Configuration => {
  return {
    auth: {
      clientId: CLIENT_ID,
      authority: `https://login.microsoftonline.com/${TENANT_ID}`,
      redirectUri: REDIRECT_URI,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return
          switch (level) {
            case 0:
              console.error('[MSAL]', message)
              return
            case 1:
              console.warn('[MSAL]', message)
              return
            case 2:
              console.info('[MSAL]', message)
              return
            case 3:
              console.debug('[MSAL]', message)
              return
          }
        },
        logLevel: import.meta.env.DEV ? 3 : 1, // Debug in dev, Warning in prod
        piiLoggingEnabled: false,
      },
    },
  }
}

// Login request scopes
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
}

// API configuration
export const apiConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  backendApiScope: 'api://1442b8da-fdf6-48cb-8867-f6578a0186d6/access_as_user',
}

// Legacy export for compatibility
export const msalConfig = getAuthConfig()
